import { useSelector } from 'react-redux';

import { selectBuildingCard } from 'shared/selectors/buildingCard';

import { BuildingBlocks } from './BuildingBlocks';

export const BuildingBlocksContainer = () => {
  const { blocks, offerCategories } = useSelector(selectBuildingCard);

  return blocks.length ? <BuildingBlocks blocks={blocks} isAfterOffers={offerCategories.length > 0} /> : null;
};
